import { render, staticRenderFns } from "./H5.vue?vue&type=template&id=5683cb4b&scoped=true"
import script from "./H5.vue?vue&type=script&lang=js"
export * from "./H5.vue?vue&type=script&lang=js"
import style0 from "./H5.vue?vue&type=style&index=0&id=5683cb4b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5683cb4b",
  null
  
)

export default component.exports